import React, { useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { useLineUpMainViewContext } from '../../contexts/LineUpMainViewContext';
import { useLineUpPlayerContext } from '../../contexts/LineUpPlayerContext';

import LineUpPitStop from './LineUpPitStop';
import makeLineUpPitStopPropsSelector from './LineUpPitStop.selector';

type PropsType = {
  className?: string;
};

const LineUpPitStopContainer = (ownProps: PropsType) => {
  const { competitorId } = useLineUpPlayerContext();
  const { matchId } = useLineUpMainViewContext();

  const selectorProps = useMemo(() => ({ competitorId, matchId }), [competitorId, matchId]);
  const selector = useMemo(() => makeLineUpPitStopPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <LineUpPitStop {...enhancedProps} />;
};

export default LineUpPitStopContainer;
